import {ActivatedRouteSnapshot, Route} from "@angular/router";
import {guardExercisesWatch} from "@/app/routes/guards/exercises-guard";
import {inject} from "@angular/core";
import {ApiService} from "@/app/api";
import {catchError, of, throwError} from "rxjs";
import {guardExercisesCategoryWatch} from "@/app/routes/guards/exercises-category-guard";

const NAME = 'Категории упражнений'

export const exerciseCategory: Route[] = [
    {
        path: 'exercise-category',
        loadComponent: () => import('@components/guides/exercise-category/exercise-category')
            .then(c => c.ExerciseCategoryComponent),
        canActivate: [guardExercisesWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: null},
            ],
            title: NAME,
            reuse: true,
            searchString: true
        },

    },
    {
        path: 'exercise-category/create',
        loadComponent: () => import('@components/guides/exercise-category/exercise-category-details/exercise-category-details.component')
            .then(c => c.ExerciseCategoryDetailsComponent),
        canActivate: [guardExercisesCategoryWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: '/exercise-category/'},
            ],
        },
        resolve: {
            exerciseCategory: (route: ActivatedRouteSnapshot) => {
                return of({id: null, name: ''})
            }
        }

    },
    {
        path: 'exercise-category/:id',
        loadComponent: () => import('@components/guides/exercise-category/exercise-category-details/exercise-category-details.component')
            .then(c => c.ExerciseCategoryDetailsComponent),
        canActivate: [guardExercisesCategoryWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: '/exercise-category/'},
            ],
        },
        resolve: {
            exerciseCategory: (route: ActivatedRouteSnapshot) => {
                const api = inject(ApiService);
                return api.ExerciseCategory.getById(route.params['id']).pipe(
                    catchError(() => {
                        // Возвращаем fallback или пробрасываем ошибку
                        return throwError(() => new Error('ExerciseCategory not found'));
                    })
                )
            }
        }

    },
]
